module.exports = __webpack_public_path__ + "img/01.499eb8b7.png";